<template>
  <el-dialog destroy-on-close :visible.sync="showDialog" title="售票统计" width="1280px" append-to-body
             :close-on-click-modal='false' :close-on-press-escape='false' :before-close="handClose">


    <custom-table @list="listBack" ref="customTable" emptyText="售票统计" :customOptions="customOptions"
                  :columns="columns"
                  :has-organization="false" maxHeight="400">
      <template slot="search-bottom">
        <div style="background-color: #fafafa;
    border: 1px solid #ebeef5;padding: 6px 6px 8px;box-sizing: border-box;margin-bottom: 10px">
          <div class="flex-start">
            <div class="items">售票金额:{{ orderInfo.orderFee || 0 }}(<span>现金:{{ orderInfo.cashFee || 0 }}，二维码:{{ orderInfo.collectionCode || 0 }}</span>)</div>
            <div class="items">售票张数:{{ orderInfo.ticketNum || 0 }}</div>


            <div class="items">保险金额:{{ orderInfo.insuranceFee || 0 }}</div>
            <div class="items">保险张数:{{ orderInfo.insuranceNum || 0 }}</div>
            <div class="items">退票手续费:{{ orderInfo.retreatFee || 0 }}</div>
            <div class="items">改签手续费:{{ orderInfo.ticketChangingFee || 0 }}</div>
            <div class="items">废票张数:{{ orderInfo.ticketCancellationNum || 0 }}</div>

          </div>
          <div class="flex-start" >
            <div class="items"  style="margin-bottom: 0">退票金额:{{ orderInfo.refundFee || 0 }}(<span>代退:{{ orderInfo.dtRefundFee || 0 }}，被代退:{{ orderInfo.bdtRefundFee || 0 }}</span>)</div>
            <div class="items"  style="margin-bottom: 0">退票张数:{{ orderInfo.ticketRefundNum || 0 }}</div>
            <div class="items"  style="margin-bottom: 0">站务费:{{ orderInfo.stationChargeFee || 0 }}</div>
            <div class="items" style="margin-bottom: 0">实收金额: <span style="color: #ff9900">{{ orderInfo.realFee || 0 }}</span></div>
          </div>


        </div>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
        <div v-else-if="item.prop == 'finishTime'">{{ row.finishTime | filterTime }}</div>
        <template v-else-if="item.prop == 'startStationName'">
          <span style="font-weight: 600">{{ row.startStationName }} - {{ row.endStationName }}</span>
        </template>

        <template v-else-if="item.prop == 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }}
        </template>

        <div v-else-if="item.prop == 'realFee'" style="color: #ff9900">
          <span v-if="row.realFee" style="color: #ff9900"> ¥{{ row.realFee }}</span>
          <span v-else>-</span>
        </div>
        <div v-else-if="item.prop == 'insuranceFee'">
          <span v-if="row.insuranceFee" style="color: #ff9900"> ¥{{ row.insuranceFee }}</span>
          <span v-else>-</span>
        </div>
        <div v-else-if="item.prop == 'status'">
          {{ row.status | filterOrderStatus }}
        </div>
        <span v-else>{{ row[item.prop] || '-' }}</span>
      </template>
    </custom-table>

  </el-dialog>
</template>

<script>


export default {
  name: "selectVote",
  components: {},
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
      showDialog: false,
      customOptions: {
        url: '/api/v1/manage/order/station/statistics',
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: 'daytime',
            clearable: false,
            field: 'Time',
            name: '统计时间',
            value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(0, 0, 0, 0)]
          },
        ]
      },
      columns: [
        {prop: "orderNo", label: "订单号", width: 190},
        {prop: "status", label: "订单状态", width: 80},
        {prop: "created", label: "下单时间", width: 130},
        {prop: "finishTime", label: "完成/取消时间", width: 130},
        {prop: "startStationName", label: "线路名称", minWidth: 140},
        {prop: "startLineTime", label: "班次", width: 90},
        {prop: "passengerNum", label: "乘客数", width: 60},
        {prop: 'ticketCurrentNo', label: "票号", width: 100},
        {prop: 'stationChargeFee', label: "站务费", width: 70},
        {prop: "realFee", label: "实付金额", width: 70},
        {prop: "insuranceNum", label: "保险张数", width: 70},
        {prop: 'insuranceFee', label: "保险金额", width: 70},
      ],
      orderInfo: {}
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.showDialog = this.value
          this.$nextTick(() => {
            this.value && this.$refs.customTable.listFn()
          })
        }
      }
    }
  },
  methods: {
    handClose() {
      this.showDialog = false
      this.$emit('input', false)
    },
    async listBack(row) {
      const url = '/api/v1/manage/order/station/statistics/count'
      const {code, data} = await this.$axios.get(url, row)
      if (code === 1 && data) {
        this.orderInfo = data
      }
    }
  }
}
</script>

<style scoped>
.items {
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 16px;
}

</style>